import React from 'react';
import PressureHolderNeed from "./PressureHolderNeed";
import PressureHolderQuantity from "./PressureHolderQuantity";
import PressureHolderType from "./PressureHolderType";

const PressureHolder = (props) => {
  const {validator, parameters} = props;
  return (
    <div className="hardware-section">
      <h5 className="hardware-title">Hardware</h5>
      {/* <PressureHolderNeed {...props} >
        {validator.message(`Presure Holder`, parameters.need_pressure_holder, 'required')}
      </PressureHolderNeed> */}
      <YesPressureHolder {...props} />
    </div>
  )
};

const YesPressureHolder = (props) => {
  const {validator, parameters} = props;

  // if (parameters.need_pressure_holder !== '1') return null;

  return (
    <>
      <PressureHolderType {...props} tooltip={props.pressureHolderTypeTooltip}>
        {validator.message(`Pressure Holder Type`, parameters.pressure_holder_type, 'required')}
      </PressureHolderType>
      <div className="row">
        <div className="col-lg-6">
          <PressureHolderQuantity {...props} >
            {parameters.pressure_holder_type && parameters.pressure_holder_type != 'none' && validator.message(`Pressure Holder Quantity`, parameters.pressure_holder_quantity, 'required|integer|min:1,num')}
          </PressureHolderQuantity>
        </div>
      </div>
    </>
  )
}

export default PressureHolder;
